// Single source of truth for the document upload allow-list (Axel-approved, fixed per
// the ticket) and the per-surface caps.
//
// CLIENT-SIDE UX ONLY — NOT A SECURITY BOUNDARY (standards rule #25 / §8.5).
// Everything here is bypassable with a crafted request. The enforcing copy is the backend's
// gptBlueVariableFileService.cfc: `allowedExtensions` holds the same 15 types, validateFiles
// re-checks extension, count and combined size per scope, uploadMultipartFiles deletes any
// part whose extension is off the list, and PDFs get a magic-byte header check. Keep the two
// lists in step: changing one alone silently splits the contract.

// START-CodeLeap [24-Aug-2026]: [#18188866946] Axel-approved allow-list (15-Jul-2026 ticket ruling)
export const ALLOWED_UPLOAD_EXTENSIONS = [
  ".pdf",
  ".txt",
  ".md",
  ".json",
  ".html",
  ".xml",
  ".doc",
  ".docx",
  ".rtf",
  ".odt",
  ".ppt",
  ".pptx",
  ".csv",
  ".xls",
  ".xlsx",
];

// Ready for an <input accept="..."> attribute.
export const ALLOWED_UPLOAD_ACCEPT = ALLOWED_UPLOAD_EXTENSIONS.join(",");
// /END-CodeLeap [24-Aug-2026]: [#18188866946]

// START-CodeLeap [24-Aug-2026]: [#18188866946] cross-field combined-size cap
// Combined size of all files across every variable field in one submit. Kept under the
// IIS 28.6 MB request ceiling.
export const VARIABLE_FILES_TOTAL_MAX_SIZE = 25 * 1024 * 1024; // 25 MB
// /END-CodeLeap [24-Aug-2026]: [#18188866946]

// START-CodeLeap [27-Aug-2026]: [#18188866946 PR-2469 review fixes] per-surface caps moved here
// Per-surface upload caps (Dino's rulings). Previously hardcoded in each of the five
// components — two of them inside the component body, so they were rebuilt every render
// and their names had drifted. Every surface now reads its pair from this one object, so a
// cap change lands in one place and can be checked against VARIABLE_FILES_TOTAL_MAX_SIZE.
export const UPLOAD_CAPS = {
  PROMPT: { maxFiles: 3, maxCombinedSize: 10 * 1024 * 1024 },
  FLIGHT: { maxFiles: 3, maxCombinedSize: 10 * 1024 * 1024 },
  MANUAL_INSTANCE: { maxFiles: 3, maxCombinedSize: 10 * 1024 * 1024 },
  CORP: { maxFiles: 5, maxCombinedSize: 25 * 1024 * 1024 },
  ORG: { maxFiles: 5, maxCombinedSize: 25 * 1024 * 1024 },
} as const;
// /END-CodeLeap [27-Aug-2026]: [#18188866946 PR-2469 review fixes]
